// ABOUTME: Divider component for visual separation of content sections.
// ABOUTME: Supports different max-widths on desktop via maxWidth prop.

import { cn } from "@shared/lib/utils"

interface CDividerProps {
  className?: string
  maxWidth?: "sm" | "md" | "lg" | "full"
}

const maxWidthClasses: Record<string, string> = {
  sm: "md:max-w-[300px]",
  md: "md:max-w-[460px]",
  lg: "md:max-w-140",
  full: "",
}

export const CDivider = ({ className, maxWidth = "full" }: CDividerProps) => {
  return <div className={cn("border-b border-gray-200 mb-5", maxWidthClasses[maxWidth], className)} />
}
